import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { NeuButton, NeuCard, NeuInput, NeuSelect } from "../../components/neu/Neu";
import { createCustomer } from "../../api/sales";

const EMPTY = { legal_name: "", name_ar: "", code: "", customer_type: "b2b", currency: "AED",
                trn: "", tin: "", credit_limit: "0.00" };

// إنشاء عميل بالحد الأدنى المطلوب للفوترة الإلكترونية.
export const CustomerForm = ({ onSaved }) => {
  const { t } = useTranslation();
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const save = async () => {
    setBusy(true);
    try {
      await createCustomer({
        legal_name: form.legal_name,
        name_ar: form.name_ar || null,
        code: form.code || null,
        customer_type: form.customer_type,
        currency: form.currency,
        tax: { trn: form.trn || null, tin: form.tin || null, country: "AE", peppol_scheme: "0235" },
        credit: { limit: form.credit_limit || "0.00", on_exceed: "warn", blocked: false },
      });
      toast.success(t("sales.customerCreated"));
      setForm(EMPTY);
      onSaved();
    } catch (error) {
      toast.error(error?.response?.data?.detail?.code === "customer_code_taken"
        ? t("sales.codeTaken") : t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <NeuCard className="grid gap-3 p-5 sm:grid-cols-4" data-testid="sales-customer-form">
      <NeuInput data-testid="customer-legal-name" placeholder={t("sales.legalName")}
                value={form.legal_name} onChange={set("legal_name")} />
      <NeuInput data-testid="customer-name-ar" placeholder={t("sales.nameAr")}
                value={form.name_ar} onChange={set("name_ar")} />
      <NeuInput data-testid="customer-code" placeholder={t("sales.code")} dir="ltr"
                value={form.code} onChange={set("code")} />
      <NeuSelect data-testid="customer-type" value={form.customer_type} onChange={set("customer_type")}>
        {["b2b", "b2c", "b2g"].map((k) => (
          <option key={k} value={k}>{t(`sales.customerType.${k}`)}</option>
        ))}
      </NeuSelect>
      <NeuInput data-testid="customer-trn" placeholder={t("sales.trn")} dir="ltr"
                value={form.trn} onChange={set("trn")} />
      <NeuInput data-testid="customer-tin" placeholder={t("sales.tin")} dir="ltr"
                value={form.tin} onChange={set("tin")} />
      <NeuInput data-testid="customer-credit" placeholder={t("sales.creditLimit")} dir="ltr"
                value={form.credit_limit} onChange={set("credit_limit")} />
      <NeuButton variant="primary" data-testid="customer-save" disabled={!form.legal_name || busy}
                 onClick={save}>
        {t("app.save")}
      </NeuButton>
    </NeuCard>
  );
};
